var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      style: !_vm.popupParam.isPop
        ? "width: 1000px; max-width: 1000px !important"
        : "",
    },
    [
      _c("c-table", {
        ref: "table",
        attrs: {
          title: "시설 목록",
          tableId: "facility",
          columns: _vm.grid.columns,
          data: _vm.grid.data,
          gridHeight: _vm.grid.height,
          columnSetting: false,
        },
        on: { linkClick: _vm.linkClick },
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }